"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default() {
  let prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return [_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m10.898 2.001 7.6377 3.5615L16 11.0003 8.3623 7.4388 10.898 2.001zm.9674 2.6578-.8452 1.8126 4.0124 1.871.8453-1.8126-4.0125-1.871z"
  }), _react.default.createElement("path", {
    d: "M10 15.0003v1.7357l-4 4.1666v1.0977H4V20.098l4-4.1667v-2.931h8v2.931l4 4.1667v1.9023h-2v-1.0977l-4-4.1666v-1.7357h-4z"
  })];
};

exports.default = _default;